import axios from 'axios'
export const api = axios.create();
api.interceptors.request.use(function (config) {
  config.baseURL = process.env.LMS_URL
  return config
})
const lmsData = {
  getProgress: (arg) => new Promise((resolve, reject) => {
    api.get('/get_course_progress/?username=' + arg)
      .then(function (response) {
        if (response.error) {
          console.log(response.error_message)
        }
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  getTutor: (arg) => new Promise((resolve, reject) => {
    api.get('/get_tutor/?username=' + arg)
      .then(function (response) {
        if (response.error) {
          console.log(response.error_message)
        }
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }), 
  setUsername: (args) => new Promise((resolve, reject) => {
    api.post('/set_username', args, {
      headers: {
        // Overwrite Axios's automatically set Content-Type
        'Content-Type': 'application/json'
      }
    })
      .then(function (response) {
        if (response.error) {
          console.log(response.error_message)
        }
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }) 
}
export default lmsData



// WEBPACK FOOTER //
// ./src/api/lmsAPI.js